'use client'

import { usePathname } from 'next/navigation'
import { useMemo } from 'react'

import { useGetCartItemsQuery } from '../api/cart-api-slice'
import { getCartCount } from '../utils/getCartCount'

export const useCartItemsData = () => {
	const pathname = usePathname()
	const isCartPage = pathname === '/cart' || pathname === '/cart/'

	const { data, isFetching, isLoading, refetch } = useGetCartItemsQuery(undefined, {
		skip: isCartPage
	})

	const cartCount = useMemo(() => (data ? getCartCount(data, true) : 0), [data])

	const getBasketItem = (id: any) => (data ? data.find(({ ID }) => ID === id) : null)

	return {
		products: data || [],
		cartCount,
		getBasketItem,
		isFetching,
		isLoading,
		refetch
	}
}
